"use client";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectGroup,
} from "@/components/ui/select";
import { Label } from "./ui/label";
import { CardDescription, CardTitle } from "./ui/card";

type LimitProps = {
  limit: number;
  setLimit: (limit: number) => void;
  useHeader?: boolean;
  customWidth?: string;
};

export function Limit({
  limit,
  setLimit,
  useHeader = false,
  customWidth,
}: LimitProps) {
  return (
    <div className={`flex flex-col ${useHeader ? "gap-5" : "gap-1"}`}>
      <div className="flex-shrink-0">
        <div className={`flex w-full flex-row items-center`}>
          {!useHeader ? (
            <Label
              htmlFor="limit"
              className={`text-sm font-bold text-neutral-800`}
            >
              Results
              <span className="text-red-600">*</span>
            </Label>
          ) : (
            <div className="min-w-0 flex-1">
              <CardTitle className="leading-normal">
                Number of Results
              </CardTitle>
              <CardDescription>
                Select the number of results you want for your data{" "}
              </CardDescription>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex-row">
        <Select
          value={String(limit)}
          onValueChange={(value) => setLimit(Number(value))}
        >
          <SelectTrigger
            className="!min-h-[45px] !shadow-none"
            style={{ width: customWidth || "100%" }}
          >
            <SelectValue placeholder="10" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectItem value="1" className="!h-[35px]">
                1
              </SelectItem>
              <SelectItem value="5">5</SelectItem>
              <SelectItem value="10">10</SelectItem>
              <SelectItem value="20">20</SelectItem>
              <SelectItem value="25">25</SelectItem>
              <SelectItem value="50">50</SelectItem>
              <SelectItem value="75">75</SelectItem>
              <SelectItem value="100">100</SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
